/**
 * Cancel page shown when user cancels Stripe Checkout
 */

import React from 'react';
import { Container, Paper, Typography, Button, Box } from '@mui/material';
import { X as CancelIcon } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const CancelPage = () => {
  const navigate = useNavigate();

  return (
    <Container maxWidth="sm" sx={{ mt: 8, textAlign: 'center' }}>
      <Paper elevation={3} sx={{ p: 6 }}>
        <CancelIcon size={80} color="var(--ab-pending)" />

        <Typography variant="h4" gutterBottom>
          Checkout Canceled
        </Typography>

        <Typography variant="body1" color="text.secondary" paragraph>
          You canceled the checkout process. No charges were made to your account.
        </Typography>

        <Typography variant="body2" color="text.secondary" paragraph>
          If you have any questions about our pricing or features, please contact support.
        </Typography>

        <Box sx={{ mt: 4, display: 'flex', gap: 2, justifyContent: 'center' }}>
          <Button
            variant="contained"
            onClick={() => navigate('/billing')}
          >
            Back to Billing
          </Button>
          <Button
            variant="outlined"
            onClick={() => navigate('/')}
          >
            Go Home
          </Button>
        </Box>
      </Paper>
    </Container>
  );
};

export default CancelPage;
